
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState, selectLanguageInCommonState } from 'app/app-state.index';
import { BusinessManagmentService } from 'app/core/services/business-managment.service';
import { BusinessManagment } from 'app/public/model/BusinessManagment';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { FieldTypes, Language } from 'app/shared/model/enums';
import { CommonService } from 'app/shared/services/common.service';
import { BehaviorSubject, map, Observable, switchMapTo, tap } from 'rxjs';
export abstract class BaseBusinessManagement {

  request: { Paging: any; Filter: { FreeSearch: string }, Language: Language, SortField: string, SortOrder: string }
  businessRoulettes$: Observable<BusinessManagment[]>;
  business: BusinessManagment
  columns: { field: string; headerTranslate: string; type?: FieldTypes; width?: string; sortable?: boolean }[] = [];
  numRowsInPage = 100;
  totalRecords: number;
  returnTotalRecords = false;
  loadBusinessRoulettesEvent$ = new BehaviorSubject(true);
  freeSearch: string;
  currentLanguage: Language;


  constructor(public localizationService: LocalizationService,
    public store: Store<AppState>,
    public commonService: CommonService,
    public businessManagment: BusinessManagmentService, public router: Router,
  ) {

  }
  init(): void {
    this.commonService.changeCurrentPageHeader(this.localizationService.Translate('MENU.BUSINESS_MANAGMENT'));
    this.store.select(selectLanguageInCommonState).subscribe(language => {
      this.currentLanguage = language
    });
    this.initColumns();
    this.createRequest();
  }
  loadBusinessRoulettes(): void {
    if (!this.businessRoulettes$) {
      this.initLoadBusinessRoulettesObservable();
    } else {
      this.loadBusinessRoulettesEvent$.next(true);
    }
  }
  initLoadBusinessRoulettesObservable(): void {
    this.businessRoulettes$ = this.loadBusinessRoulettesEvent$.pipe(
      switchMapTo(
        this.businessManagment.getBusinessRoulettes(this.request).pipe(
          tap(res => {
            this.totalRecords = res.TotalCount;
            if (this.totalRecords) this.returnTotalRecords = true;
          }),
          map(res => res.BusinessRoulettes)
        )
      )
    );
  }

  OnViewBusinessDetails(event) {
    this.business = event.selectedRow;
    this.router.navigate(['webplatform','business-details', this.business.BusinessId]);
  }
  createRequest(pageNo?: number) {
    this.request = {
      Paging: {
        PageNo: pageNo ? pageNo : 1,
        NumberRowsInPage: this.numRowsInPage
      },
      Filter: {
        FreeSearch: this.freeSearch,
      },
      Language: this.currentLanguage,
      SortField: null,
      SortOrder: null
    };
    if (pageNo) {
      this.initLoadBusinessRoulettesObservable();
    }
  }
  onSort(event: any) {
    if (event.multisortmeta && event.multisortmeta.length > 0) {
      const sortField = event.multisortmeta[0].field;
      const sortOrder = event.multisortmeta[0].order === 1 ? 'asc' : 'desc';
      this.request.SortField = sortField;
      this.request.SortOrder = sortOrder;

      this.loadBusinessRoulettes();
    }
  }

  filterfreeSearch() {
    this.request.Filter.FreeSearch = this.freeSearch ? this.freeSearch : null;
    this.loadBusinessRoulettes()
  }
  public initColumns() {
    this.columns = [
      { field: 'BusinessId', headerTranslate: 'BUSINESS_MANAGEMENT.BUSINESS_ID', sortable: true },
      { field: 'BusinessName', headerTranslate: 'BUSINESS_MANAGEMENT.BUSINESS_NAME', sortable: true },
      { field: 'CreatedDate', headerTranslate: 'BUSINESS_MANAGEMENT.CREATED_DATE', type: FieldTypes.fullDate, sortable: true },
      { field: 'FullAddress', headerTranslate: 'BUSINESS_MANAGEMENT.ADDRESS', sortable: true },
      { field: 'Country', headerTranslate: 'BUSINESS_MANAGEMENT.COUNTRY', sortable: true },
      { field: 'TotalRoulettesCount', headerTranslate: 'BUSINESS_MANAGEMENT.TOTAL_ROULETTES_COUNT', sortable: true },
      { field: 'ActiveRoulettesCount', headerTranslate: 'BUSINESS_MANAGEMENT.ACTIVE_ROULETTES_COUNT', sortable: true },
      { field: 'InactiveRoulettesCount', headerTranslate: 'BUSINESS_MANAGEMENT.INACTIVE_ROULETTES_COUNT', sortable: true },
      { field: 'LeadsCount', headerTranslate: 'BUSINESS_MANAGEMENT.LEADS_COUNT', sortable: true },
    ];
  }
}